// Generated by CoffeeScript 1.11.1
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/get_hostname',['./parse_url'], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory(require('./parse_url'));
  } else {
    return root.getHostname = factory(root.parseUrl);
  }
})(this, function(parseUrl) {

  /**
  	Retrieves a hostname from a url
  
  	@method getHostname
  	@return {String}
   */
  var getHostname;
  return getHostname = function(url) {
    return parseUrl(url).hostname;
  };
});

